


























import { mapGetters } from 'vuex'
import Vue from 'vue'
export default Vue.extend({
    data() {
        return {
            alert: false,
            default: 2000 //  Default timeout 2 seconds
        }
    },
    mounted() {
        //  Initialize the bar
        this.init()
    },
    computed: {
        ...mapGetters({
            bar: 'appNotificationBar'
        }),
        cls(): string {
            //  If the bar does NOT exists, return nothing
            if (!this.bar) return null

            //  If the 'position' prop is set to 'bottom', return bottom bar
            if (this.bar.position === 'bottom') return 'bar bottom'

            //  Else return top bar
            return 'bar'
        },
        style(): object {
            return {
                position: 'fixed',
                height: '30px',
                width: '100%',
                top: '39px',
                background: 'transparent',
                'pointer-events': 'none',
                'z-index': '6'
            }
        },
        enterActive(): string {
            if (!this.bar) return null
            if (this.bar.position === 'bottom') return 'animated slideInUp'
            return 'animated slideInDown'
        },
        leaveActive(): string {
            if (!this.bar) return null
            if (this.bar.position === 'bottom') return 'animated slideOutDown'
            return 'animated slideOutUp'
        }
    },
    methods: {
        close(): void {
            this.$store.commit('appNotificationBarSet')
        },
        init(): boolean {
            //  If the bar is null, set alert to false
            if (!this.bar) return (this.alert = false)

            //  Else, pop notification
            this.alert = true
            this.pop()
        },
        pop(): void {
            if (!this.bar.closeable) {
                //  if the user set the timeout...
                if (this.bar.timeout) {
                    //  ... set the timeout from user input
                    setTimeout(this.close, this.bar.timeout)
                } else {
                    //  else, set the default timeout
                    setTimeout(this.close, this.default)
                }
            }
        },
        redirect(): void {
            if (this.bar.link) {
                if (this.$route.path != this.bar.link) this.$router.push(this.bar.link)
            } else {
                this.close()
            }
        },
        run(method: string): void {
            //  If method variable is nul (no method attached to button), do nothing
            if (!method) return

            //  Else, run method
            this[method]()
        }
    },
    watch: {
        bar(): void {
            this.init()
        }
    }
})
